import React from 'react'
import _ from 'lodash'
import { use } from 'xadmin'
import { _t } from 'xadmin-i18n'
import { ModelBlock } from 'xadmin-model'
import { C, Icon, Page, Loading } from 'xadmin-ui'
import { Button, Dropdown, Menu, Popover, Checkbox, Row, Col, Input, Layout } from 'antd'
const { Content, Sider } = Layout

const CountButton = props => {
  const { count } = use('model.count', props)
  return <Button>{_t('{{count}} records', { count })}</Button>
}

const PageSizeButton = props => {
  const { size, sizes, setPageSize } = use('model.pagesize', props)
  const [visible, setVisible] = React.useState(false)
  const input = React.createRef()

  const onSetPageSize = (size) => {
    setPageSize(size)
    setVisible(false)
  }

  const onInputSize = (e) => {
    if (e.key == 'Enter') {
      const size = parseInt(input.current.input.value)
      onSetPageSize(size)
      input.current.setState({ value: '' })
    }
    e.persist()
  }

  return (
    <Dropdown key="page-size-dropdown" onVisibleChange={setVisible} visible={visible} overlay={(
      <Menu>
        {sizes.map(size => <Menu.Item key={`size-${size}`} onClick={() => setPageSize(size)} eventKey={`size-${size}`}>{_t('Set {{size}} per page', { size })}</Menu.Item>)}
        <Menu.Item key="size-custom">
          <Input placeholder={_t('Customize page size')} ref={input} precision={0} onKeyPress={onInputSize} style={{ width: 100 }} />
        </Menu.Item>
      </Menu>
    )}>
      <Button>
        {_t('{{size}} per page', { size })}
      </Button>
    </Dropdown>
  )
}

const ColsDropdown = props => {
  const { selected, fields, changeFieldDisplay } = use('model.fields', props)

  let items = []
  const showFields = Object.keys(fields).filter(name => fields[name].showInList !== false)
  const menuShow = showFields.length <= 10

  for (let name of showFields) {
    let field = fields[name]
      , fieldName = name
      , title = field?.title || name
      , fieldSelected = _.indexOf(selected, name) !== -1
      , onClick = (e) => {
        changeFieldDisplay([fieldName, e.target.checked])
      }, onClickBtn = () => {
        changeFieldDisplay([fieldName, !fieldSelected])
      }
    if (menuShow) {
      items.push(<Checkbox key={name} onChange={onClick} checked={fieldSelected}>{title}</Checkbox>)
    } else {
      items.push((
        <Col span={3} key={name} style={{ margin: '5px 0' }}>
          <Button type={fieldSelected ? 'primary' : 'default'} block onClick={onClickBtn}>{title}</Button>
        </Col>))
    }
  }

  return (
    <Popover placement="bottomRight" overlayStyle={{ maxWidth: '80%' }} content={(
      menuShow ? items :
        <Row gutter={12}>{items}</Row>
    )} trigger="click">
      <Button>{_t('Columns')}</Button>
    </Popover>
  )
}

const ListSubMenu = ({ children }) => (
  <div>
    <CountButton />{' '}
    {/* <PageSizeButton />{' '} */}
    <ModelBlock name="model.list.submenu.btngroup" />
    <ColsDropdown />
    {children}
  </div>
)


const DefaultAddButton = ({ onAdd, children }) => (
  <Button type="primary" onClick={onAdd}>{children}</Button>
)

const DptListPage = ({ location }) => {
  const { model } = use('model')
  const { canAdd } = use('model.permission')
  const { onAdd } = use('model.event')

  const ItemsComponent = (model.components && model.components.DataList) || C('Model.DataTable')
  const query = location && location.query

  let icon = model.icon || model.name
  if (_.isString(icon)) {
    icon = <Icon name={icon} />
  }
  const title = model?.title

  const renderActions = () => {
    const AddButton = (model.components && model.components.AddButton) || C('Model.AddButton') || DefaultAddButton
    return (<>
      <ModelBlock name="model.list.navbtn" />
      { canAdd ?
        (<AddButton onAdd={onAdd}><Icon name="plus" /> {_t('Add {{object}}', { object: model.title })}</AddButton>) : null
      }
    </>)
  }

  const GridComponents = [
    <div key="model-list-subnav" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '.5rem' }}>
      <C is="Model.ActionBar" />
      <ListSubMenu />
    </div>,
    <ItemsComponent key="model-list-grid" query={query} />,
  ]

  return (
    <ModelBlock name="model.list.sidemenu" >
      { sideMenu => (
        <Page className={`xadmin-model-list-${model.key}`}
          title={(<span>{icon} {title}</span>)}
          sider={sideMenu}
          subTitle={<ModelBlock name="model.list.nav" />}
          actions={renderActions()}>
          <ModelBlock name="model.list.submenu" />
          <ModelBlock name="model.list.sidepanel" >
            {sidePanel => sidePanel ? (
              <Layout>
                <Content>{GridComponents}</Content>
                { sidePanel ? <Sider width={200} style={{ backgroundColor: 'transparent', marginLeft: '.5rem' }}>{sidePanel}</Sider> : null}
              </Layout>
            ) : GridComponents}
          </ModelBlock>
        </Page>
      )}
    </ModelBlock>
  )
}

export default DptListPage
